import { House } from '@/client';

export const isHouseSetupComplete = (house: House): boolean => {
	return !!house.onboarded;
};

export const isDraftHouse = (house: House): boolean => {
	return !isHouseSetupComplete(house);
};

/**
 * Returns the timestamp (ISO string) of the latest transfer, or null if none.
 */
export const getLastTransferAt = (house: House): string | null => {
	const ownerHistory = (house.owner_history ?? []) as { transferred_at?: string | null }[];
	if (ownerHistory.length === 0) return null;
	const last = [...ownerHistory].sort(
		(a, b) => new Date(b?.transferred_at ?? 0).getTime() - new Date(a?.transferred_at ?? 0).getTime(),
	)[0];
	return last?.transferred_at ?? null;
};

export const houseSelectors = {
	findById: <T extends House>(houses: T[], id: number): T | null => houses.find((doc) => doc.id === id) ?? null,

	complete: <T extends House>(houses: T[]): T[] => houses.filter(isHouseSetupComplete),
	// A not-yet-onboarded archive (non-null original_house_id) is the professional's retention copy
	// mid-build, not a user's own draft, so it is excluded here to stay out of the property list.
	drafts: <T extends House>(houses: T[]): T[] =>
		houses.filter((house) => isDraftHouse(house) && !house.original_house_id),
};
